import { SafePromise, SafeError } from '@benzinga/safe-await';
import { SupportedTickersResponse, SupportedTickers } from './entities';

export const ingestSupportedTickers = async (
  data: SafePromise<SupportedTickersResponse>,
): SafePromise<SupportedTickers> => {
  const response = await data;

  if (response.err) {
    return { err: response.err };
  } else {
    if (response.ok && response.ok.data) {
      const result = response.ok.data;
      return {
        ok: {
          last_updated: result.last_updated,
          tickers: result.tickers ? Object.values(result.tickers || {}).map(ticker => ticker.symbol) : [],
        },
      };
    } else {
      return { err: new SafeError('did not get a valid supported tickers response', 'invalid_supported_tickers') };
    }
  }
};
